import { useEffect, useRef, useState } from "react";

// Adds 'is-visible' class to .reveal children when they scroll into view.
export const useReveal = () => {
  const ref = useRef(null);
  const [seen, setSeen] = useState(false);
  useEffect(() => {
    if (!ref.current || seen) return;
    const node = ref.current;
    const io = new IntersectionObserver(
      (entries) => {
        entries.forEach((e) => {
          if (e.isIntersecting) {
            e.target.classList.add("is-visible");
            io.unobserve(e.target);
          }
        });
      },
      { threshold: 0.12 }
    );
    node.querySelectorAll(".reveal").forEach((el) => io.observe(el));
    setSeen(true);
    return () => io.disconnect();
  }, [seen]);
  return ref;
};
